import { useEffect, useState } from "react";
import api, { formatBRL } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Copy, Loader2 } from "lucide-react";
import { toast } from "sonner";

function listaTexto(grupos) {
  return grupos.map((g) => [
    `${g.nome} (${g.mes})`,
    ...g.cursos.map((c) => `  - ${c.rotulo} · ${c.nucleo_nome || "sem núcleo"} · ${c.local_realizacao || "sem local"} · ${c.vendas} venda(s) · ${formatBRL(c.valor)}`),
  ].join("\n")).join("\n\n");
}

function Grupo({ g }) {
  return (
    <div className="rounded-xl border border-slate-200 p-3" data-testid="duplicado-grupo">
      <div className="font-bold text-slate-900 text-sm">{g.nome} <span className="text-slate-400 font-normal">· {g.mes || "sem data"}</span></div>
      <table className="w-full text-xs mt-2">
        <thead><tr className="text-left text-slate-500 uppercase tracking-wider"><th className="py-1">Curso</th><th>Núcleo</th><th>Local</th><th className="text-right">Vendas</th><th className="text-right">Valor</th></tr></thead>
        <tbody>
          {g.cursos.map((c) => (
            <tr key={c.id} className="border-t border-slate-100" data-testid={`duplicado-curso-${c.id}`}>
              <td className="py-1 pr-2">{c.rotulo}</td><td className="pr-2">{c.nucleo_nome || "—"}</td>
              <td className="pr-2">{c.local_realizacao || "—"}</td><td className="text-right tabular-nums">{c.vendas}</td>
              <td className="text-right tabular-nums">{formatBRL(c.valor)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function CursosDuplicadosModal({ open, onClose }) {
  const [grupos, setGrupos] = useState(null);
  useEffect(() => {
    if (!open) return;
    setGrupos(null);
    api.get("/cursos-duplicados").then((r) => setGrupos(r.data || [])).catch(() => setGrupos([]));
  }, [open]);
  const copiar = async () => {
    try { await navigator.clipboard.writeText(listaTexto(grupos)); toast.success("Lista copiada · cole no e-mail ou WhatsApp para validar"); }
    catch { toast.error("Não consegui copiar"); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-3xl max-h-[88vh] overflow-y-auto" data-testid="modal-duplicados">
        <DialogHeader>
          <DialogTitle>Possíveis cursos duplicados</DialogTitle>
          <DialogDescription>Cursos com o mesmo nome no mesmo mês. Confira se não são turmas diferentes antes de unificar. Esta tela não altera nada.</DialogDescription>
        </DialogHeader>
        {grupos === null && <div className="py-8 flex justify-center text-slate-500"><Loader2 className="w-5 h-5 animate-spin" /></div>}
        {grupos?.length === 0 && <div className="py-6 text-center text-slate-400 text-sm" data-testid="duplicados-vazio">Nenhum curso duplicado encontrado.</div>}
        <div className="space-y-3">{(grupos || []).map((g) => <Grupo key={`${g.nome}-${g.mes}`} g={g} />)}</div>
        <DialogFooter>
          {grupos?.length > 0 && <Button variant="outline" onClick={copiar} data-testid="btn-copiar-duplicados"><Copy className="w-4 h-4 mr-1" /> Copiar lista</Button>}
          <Button onClick={onClose} data-testid="btn-fechar-duplicados">Fechar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
